export const navigation = [
  {
    to: '/',
    label: 'Home',
    exact: true
  },
  {
    to: '/works',
    label: 'Music',
    exact: false
  },
  {
    to: '/listen',
    label: 'Listen',
    exact: false
  },
  {
    to: '/recordings',
    label: 'Recordings',
    exact: false
  },
  {
    to: '/writings',
    label: 'Writings',
    exact: false
  },
  {
    to: '/events',
    label: 'News/Events',
    exact: false
  },
  {
    to: '/guildhianmusic',
    label: 'GuildhianMusic',
    exact: false
  },
  {
    to: '/about',
    label: 'About',
    exact: false
  },
  {
    to: '/contact',
    label: 'Contact',
    exact: false
  }
]
